import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
  sendRequest,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import TasksListNewTasks from '../../../../../components/Tasks/TasksListNewTasks';

class NewTasksList extends Component {
  componentWillMount() {
    this.props.changeDefaultQueryParams({
      page: 1,
      sort: '-created_at',
      hide_from_black_list: '1'
    });
    this.props.sendRequest();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <TasksListNewTasks reducerName={this.props.listReduceName} />;
  }
}

NewTasksList.propTypes = {
  // IN
  listReduceName: PropTypes.string.isRequired,

  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    () => ({}),
    mapDispatchToProps
  )(NewTasksList)
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/NewTasksList/NewTasksList.js